export enum NameField {
	DISPLAY_NAME = "display_name",
}

export interface NameData {
	[NameField.DISPLAY_NAME]?: string,
}